<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: Duel to the Death, by J.A. Jance" class="imagefp" src="images/9781501151002.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?e0f6950a